const initialState = {
    data: [],
  };
  
  const grupyReducerAll = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_GRUPY_ALL':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default grupyReducerAll;